import { Box } from "@mui/material";
import {
  DataGridPremium,
  GridColDef,
  GridRowOrderChangeParams,
  GridPinnedRowsProp,
  GridValidRowModel,
} from "@mui/x-data-grid-premium";

interface SubmissionFormDatagridProps<T extends GridValidRowModel> {
  rows: T[];
  columns: GridColDef<T>[];
  onRowClick?: () => void;
  rowReordering?: boolean;
  pinnedRows?: GridPinnedRowsProp<T>;
  onRowOrderChange?: (params: GridRowOrderChangeParams) => void;
  noRowsLabel?: string;
  showClickableCursor?: boolean;
  loading?: boolean;
}

export function SubmissionFormDatagrid<T extends { id: string | number }>({
  rows,
  columns,
  onRowClick,
  rowReordering = false,
  pinnedRows,
  onRowOrderChange,
  noRowsLabel,
  showClickableCursor = false,
  loading = false,
}: SubmissionFormDatagridProps<T>) {
  return (
    <Box sx={{ mt: 1 }}>
      <DataGridPremium
        rows={rows}
        columns={columns}
        rowReordering={rowReordering}
        pinnedRows={pinnedRows}
        onRowOrderChange={onRowOrderChange}
        onRowClick={onRowClick}
        hideFooter
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableColumnReorder
        sortingOrder={[]}
        rowHeight={48}
        columnHeaderHeight={40}
        rowSelection={false}
        loading={loading}
        localeText={{
          noRowsLabel: noRowsLabel || "No rows",
        }}
        sx={{
          "& .MuiDataGrid-cell": {
            borderRight: "none",
            borderBottom: "1px solid #f0f0f0",
          },
          "& .MuiDataGrid-columnHeaders": {
            "& .MuiDataGrid-columnHeader": {
              borderRight: "none",
            },
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          ...(showClickableCursor && {
            "& .MuiDataGrid-row": {
              cursor: "pointer",
            },
          }),
          mt: 1,
        }}
      />
    </Box>
  );
}
